export default {
  toasts: {
    failed_to_delete_website: 'Falha ao eliminar website',
    website_deleted: 'Website eliminado',
  },
  delete_model: {
    title: 'Tem a certeza que quer eliminar o website?',
    confirm: 'Eliminar',
    cancel: 'Cancelar',
  },
  buttons: {
    open_editor: 'Abrir editor',
    transfer_website: 'Transferir Website',
    delete_site: 'Eliminar',
  },
};
